<template>
	<section class="navigation-drawer"
		@mouseenter="mouseOverDrawer"
		@mouseleave="mouseOffDrawer">
		<v-navigation-drawer
			app dark fixed stateless
			width="0"
			:height="getNavbarHeight()"
			:class="{ open: openState }"
			@transitionend="transitionEnd"
			v-model="vuetifyDrawerState">

			<div class="navigation-drawer__inner">
				<navigation-user-content />
				<div class="navigation-drawer__logo">
					<img :src="siteLogo"></img>
				</div>
				<v-list class="navigation-drawer__navlist">
					<!-- Standard version of navbar -->
					<div v-if="!mobile" @mouseenter="openDrawer()">
						<navigation-menu-item
							v-for="item in filterNavItems"
							:key="generateUniqueHash(item)"
							:menu-item="item"
							:is-drawer-open="isOpen"
							v-on:menu-hover="mouseOverMenu"
							v-on:menu-hoveroff="mouseOffMenu"
							/>
					</div>
					<!-- Mobile version of navbar -->
					<div v-if="mobile">
						<navigation-mobile-menu-item
							v-for="item in filterNavItems"
							:key="generateUniqueHash(item)"
							:menu-item="item"
						/>
					</div>

				</v-list>


			</div>
		</v-navigation-drawer>

	</section>
</template>


<script>
	import { mapActions, mapState, mapGetters } from 'vuex'
	import { mapFields } from 'vuex-map-fields'

	import sitenav from '@/config/sitenav'

	import {
		VUEX_UI_SHOW_NAVIGATION_DRAWER,
		VUEX_UI_HIDE_NAVIGATION_DRAWER
	} from '@/store/constants/ui'

	import Navigation_UserContent from '@/components/ui/Navigation/Navigation_UserContent.vue'
	import Navigation_MenuItem from '@/components/ui/Navigation/Navigation_MenuItem.vue'
	import Navigation_Mobile_MenuItem from '@/components/ui/Navigation/Navigation_Mobile_MenuItem.vue'


	export default {
		components: {
			'navigation-user-content' 	  : Navigation_UserContent,
			'navigation-menu-item'   	  : Navigation_MenuItem,
			'navigation-mobile-menu-item' : Navigation_Mobile_MenuItem
		},

		data:() => ({
			navigationIsHovered: false,
			menuIsHovered: false,
			closeFunc: null,
			navItems: sitenav,
			isOpen: false,
			menuHoverOnId: null,
			hideForMobile: false,
			siteLogo: require('@/assets/images/skechers_sila_2-0.svg')
		}),

		computed: {
			...mapState({
				currentUser: state => state.auth.currentUser,
				openState: state => state.ui.navigationDrawer.openState,
				mobile: state => state.mobile.mobile,
				openChildren: state => state.ui.mobileChild.childrenOpen
			}),

			...mapFields({
				vuetifyDrawerState: 'ui.navigationDrawer.vuetifyDrawerState',
			}),

			...mapGetters({
				currentUserHasPerm: 'currentUserHasPerm',
				currentUserHasRole: 'currentUserHasRole'
			}),

			filterNavItems() {
			    const navItems = this.navItems.filter(navItem => {
					const permission = navItem.permission
					const roles = navItem.roles

					// Only display nav items if route has roles and user roles match
					if (roles) {
						let match = roles.flatMap(role => {
							return this.currentUser.roles.filter(u_role => {
								if (window[role] === u_role) return true
							})
						})

						if (typeof match !== "object") return false
						if (match.length === 0) return false
					}

					if (permission && permission !== '' && this.currentUserHasPerm(window[permission]) === false) {
						return false
					}

					if ((navItem.label === 'Manage Users' || navItem.label === "Project Tools") && this.mobile === true) {
						return false
					}
					return true
				})
                return navItems
			},

			filterMobileNavItems() {
				const navItems = this.navItems.filter(navItem => {
					const permission = navItem.permission

					if (permission && this.currentUserHasPerm(window[permission]) === false) {
						return false
					}

					if (navItem.label === this.mobileSelected) {
						return true
					}
					return false
				})
				return navItems
			},
		},

		methods: {
			...mapActions({
				openDrawer:  VUEX_UI_SHOW_NAVIGATION_DRAWER,
				closeDrawer: VUEX_UI_HIDE_NAVIGATION_DRAWER
			}),

			transitionEnd() {
				this.isOpen = this.openState
			},

			mouseOverDrawer() {
				this.navigationIsHovered = true
			},

			mouseOffDrawer() {
				this.navigationIsHovered = false
				this.checkClose()
			},

			mouseOverMenu(menuHoverOnId) {
				this.menuIsHovered = true
				this.menuHoverOnId = menuHoverOnId
			},

			mouseOffMenu(menuHoverOffId) {
				if (this.menuHoverOnId !== menuHoverOffId)
					return

				this.menuIsHovered = false
				this.checkClose()
			},

			checkClose() {
				if (!this.navigationIsHovered && !this.menuIsHovered) {
					this.closeDrawer()
					this.mobileSelected = null
				}
			},

			getNavbarHeight() {

				if (this.mobile === false) {
					return "100%"
				}
				let height;
				switch (window.orientation) {
						case 0:
							height = "80vh"
							break;
						case 180:
							height = "80vh"
							break;
						case -90:
							height = "140vh"
							break;
						case 90:
							height = "140vh"
							break;
						}
				return height
			}

		},
	}
</script>

